//@ts-nocheck
// import "@tuteria/shared-lib/src/old-admin/AdminModal/admin-modal.css";
import ThemeProvider from "@tuteria/shared-lib/src/bootstrap";
import { OverlayRouter } from "@tuteria/shared-lib/src/components/OverlayRouter";
import React from "react";
import ReactDOM from "@tuteria/shared-lib/src/react-dom";
import { initializeStore } from "./adapter";
import { SubjectWithGeneric } from "@tuteria/shared-lib/src/tutor-revamp/SubjectWithGeneric";

export const unMountJobApplication = () => {
  ReactDOM.unmountComponentAtNode(document.getElementById("entryBtn"));
};

export const renderJobApplicationButton = ({
  baseUrl,
  initialData,
  onSubmit,
  buttonText = "Send my entry",
}) => {
  const { store } = initializeStore(baseUrl, initialData);
  // const { store, adapter } = initializeStore(baseUrl, initialData[kind]);
  ReactDOM.render(
    <ThemeProvider>
      <OverlayRouter>
        <SubjectWithGeneric
          store={store}
          onSubmit={onSubmit}
          buttonText={buttonText}
        />
      </OverlayRouter>
    </ThemeProvider>,
    document.getElementById("entryBtn")
  );
};
